


































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import fieldData from "@/ts/FormData";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import { IMaterialItemVueModel } from "@/ts/models/IMaterialItemVueModel";
import { ICCDDActivitiesVueModel } from "@/ts/models/ICCDDActivitiesVueModel";

@Component({
    props: {
        form: {
            type: Object as () => ICCDDActivitiesVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class CCDDActivitiesMaterials extends Vue {
    name: string = "CCDDActivitiesMaterials";
    title: string = "";

    errorMsgs = ErrorMessages;
    materialNames = fieldData.materialNames;

    mounted(): void {
        this.title = this.$props.vueStates.views[1].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 1);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[1].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[1].visited = true;

        if (this.$props.form.materials.length === 0) {
            this.addMaterial();
        }

        this.$watch("form.materials", (n, o) => {
            
        }, { immediate: true, deep: true });
    }

    get hasMaterialErrors(): boolean {
        let materials = this.$props.form.materials as IMaterialItemVueModel[];
        return materials.some((m, ix, arr) => this.isMaterialError(ix));
    }

    isMaterialNameError(index: number): boolean {
        return func.isNullOrEmpty(this.$props.form.materials[index].name);
    }

    isMaterialOverrideNameError(index: number): boolean {
        if (this.$props.form.materials[index].name != 'Other') return false;

        return func.isNullOrEmpty(this.$props.form.materials[index].overrideName);
    }

    isMaterialAmountError(index: number): boolean {
        return func.isNullOrEmptyOrZero(this.$props.form.materials[index].amount) || this.$props.form.materials[index].amount <= 0;
    }

    isMaterialWholeError(index: number): boolean {
        return !Number.isInteger(+this.$props.form.materials[index].amount) || this.$props.form.materials[index].amount.toString().includes('.');
    }

    private isMaterialError(index: number): boolean {
        return this.isMaterialNameError(index) || this.isMaterialAmountError(index);
    }

    addMaterial(): void {
        this.$props.form.materials.push(fieldData.reportingMaterials.emptyMaterialItem);
    }

    removeMaterial(materialId: string): void {
        let materials = this.$props.form.materials as IMaterialItemVueModel[];
        let index = materials.map((item) => item.id).indexOf(materialId);
        materials.splice(index, 1);
    }

    resetMaterialOverrideName(index: number) {
        if (this.$props.form.materials[index].name != 'Other') {
            this.$props.form.materials[index].overrideName = '';
        }
    }

    get hasErrors(): boolean {
        return this.hasMaterialErrors;
    }
}
